"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationMessage = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@food/ui/build/dist/src/Button");
const css_manager_1 = require("@food/css-manager");
const style = (0, css_manager_1.registerClass)((theme, sc) => `
	> button {
		width: 100%;
		margin-bottom: ${theme.ratios.l / 2}em;
	}
	
	.${sc('strong')} {
		font-weight: ${theme.font.weights.bold};
	}`);
const VerificationMessage = ({ workEmail, isModal, t, footer, close, returnToAskEmail, logout, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null, t `Registration - Business Profile`),
    react_1.default.createElement("section", { className: style },
        react_1.default.createElement("p", null,
            t `We sent you a verification email to`,
            ' ',
            react_1.default.createElement("span", { className: (0, css_manager_1.subClass)(style, 'strong') }, workEmail),
            react_1.default.createElement("br", null),
            t `Please click the link in it to complete the registration`),
        react_1.default.createElement("div", { className: footer },
            react_1.default.createElement(Button_1.Button, { label: t `Change work email`, onClick: returnToAskEmail }),
            isModal && react_1.default.createElement(Button_1.Button, { label: t `Close`, onClick: () => close() }),
            !isModal && react_1.default.createElement(Button_1.Button, { label: t `Proceed`, onClick: () => logout() })))));
exports.VerificationMessage = VerificationMessage;
//# sourceMappingURL=VerificationMessage.js.map